import { GenericService } from './details.model';

export class Kiosk extends GenericService {}

// TODO combine with kiosks.model.ts
